import DescriptionIcon from "@mui/icons-material/Description";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import { IconButton, Popover, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Box } from "@mui/system";
import { useState } from "react";
import { DaysInWeek, DaysInWeekSelector } from "../../../components/RecurringShift/util/DaysInWeekSelector";
import SystemButton from "../../../components/UIToolkit/SystemButton/SystemButton";
import { INK, NEUTRAL } from "../../../theme/tokens";

export const ReportSchedule = () => {
	const [selectedDays, setSelectedDays] = useState<DaysInWeek[]>([DaysInWeek.monday]);
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<>
			<IconButton sx={{ color: INK.SECONDARY }} onClick={handleClick} size="small">
				<EmailIcon />
			</IconButton>
			<Popover open={open} anchorEl={anchorEl} onClose={handleClose} title={"Push Report Schedule"}>
				<Box
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
						gap: 2,
						width: 500,
					}}
				>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							gap: 1,
						}}
					>
						<DescriptionIcon sx={{ color: INK.SECONDARY }} />
						<Typography
							variant="h6"
							sx={(theme) => ({
								fontWeight: 600,
								color: theme.palette.primary.main,
							})}
						>
							Push Report Schedule
						</Typography>
					</Box>
					<Box sx={{ backgroundColor: alpha(NEUTRAL[150], 0.5), padding: 2, display: "flex", flexDirection: "column", gap: 2 }}>
						<Typography>Repeat weekly on</Typography>
						<DaysInWeekSelector selectedDays={selectedDays} onChange={setSelectedDays} gap={1.25} />
						<Typography sx={{ color: INK.SECONDARY, fontSize: "14px", fontWeight: 400 }}>Occurs weekly on {selectedDays.join(", ")}</Typography>
					</Box>
					<Box
						sx={{
							display: "flex",
							justifyContent: "flex-end",
							gap: 2,
						}}
					>
						<SystemButton buttonVariant={"secondary"} onClick={handleClose}>
							Cancel
						</SystemButton>
						<SystemButton buttonVariant={"primary"} onClick={handleClose}>
							Save
						</SystemButton>
					</Box>
				</Box>
			</Popover>
		</>
	);
};
